export default {
	CPU: 'CPU',
	IP: 'IP',
	vps_console: {
		IP: 'IP',
		IPv4: 'IPv4',
		network_table: {
			'30_day': '過去 30 日間',
			'7_day': '過去 7 日間',
			to_day: '今日',
			to_month: '先月',
		},
		'1个月': '1ヶ月',
		'1年': '1年',
		'1小时': '1時間',
		'24小时': '24時間',
		'7天': '7日',
		百分比: '割合',
		操作日志: '操作ログ',
		操作系统: 'オペレーティング·システム',
		操作已取消: '操作がキャンセルされました',
		出带宽: '出力帯域幅',
		出站: '送信',
		创建时间: '作成時間',
		磁盘名称: 'ディスク名',
		磁盘信息: 'ディスク情報',
		等待重启: '再起動待ち',
		读取速度: '読み取り速度',
		读取IOPS: '読み取りIOPS',
		断电关机: '電源を切ってシャットダウンする',
		发送流量: '送信',
		分钟: '分',
		复制: 'コピー',
		概览: '概要',
		概要: '概要',
		格式化数据盘: 'データディスクをフォーマット',
		挂载: 'マウント',
		关机: 'シャットダウン',
		将重建至: '再構築先',
		接收流量: '受信',
		结束时间: '終了時刻',
		进带宽: '帯域幅に',
		进度: '進捗',
		敬请期待: '近日公開',
		开机: '電源を入れる',
		开始时间: '開始時刻',
		控制台: 'コンソール',
		类型: 'タイプ',
		类型大小: 'タイプサイズ',
		流出: '流出する',
		流出流量: '送信',
		流量: 'トラフィック',
		流量计费统计: 'トラフィック課金統計',
		流入: '流入',
		流入流量: '受信',
		秒: '秒',
		内存用量: 'メモリ使用量',
		平均流量: '平均',
		'请求超时，请稍后刷新页面查看': 'リクエストがタイムアウトしました。後でページを更新してみてください。',
		请输入端口: 'ポートを入力してください',
		请输入密码: 'パスワードを入力してください',
		请先确认数据已完成备份: '先にデータのバックアップを確認してください',
		请选择操作系统: 'OSを選択してください',
		确定要断电关机吗: '確定要電源を切ってシャットダウンしますか？',
		确定要关机吗: '確定要シャットダウンしますか？',
		确定要重启吗: '確定要再起動しますか？',
		任务: 'タスク',
		任务类型: 'タイプ',
		任务描述: '説明',
		入站: '受信',
		实例ID: 'インスタンスID',
		随机生成: 'ランダム生成',
		天: '日',
		图表: 'チャート',
		网卡: 'ネットワーク',
		我确认数据已完成备份: 'データのバックアップを確認しました',
		系统重装中: '再インストール中です。後ほどページを更新して結果をご確認ください',
		小时: '時間',
		写入速度: '書き込み速度',
		写入IOPS: '書き込みIOPS',
		已持续运行: '運行中',
		已关机: 'シャットダウン',
		已用: '使用済み',
		硬盘IO: 'ディスクI/O',
		硬重启: 'ハードリブート',
		用户名密码: 'ユーザー名とパスワード',
		远程: 'リモート',
		运行中: '運行中',
		正在重置密码: 'パスワードをリセットしています',
		正在重装: '再インストール中',
		执行中: '実行中',
		重建实例: 'インスタンスを再構築',
		重建实例警告:
			'再構築するとすべての個人データが消去されます。バックアップが完了したことを確認してください。このインスタンスを再構築してもよろしいですか？',
		重启: '再起動',
		重置密码: 'パスワードをリセットする',
		重装: '再インストール',
		重装系统将会导致系统盘数据丢失: '再インストールするとシステムディスクのデータがすべて消去されます。続行しますか？',
		重装系统确认: '再インストールの確認',
		主: 'ホスト',
		主机名: 'ホスト名',
		总计流量: '合計',
		总量: '合計金額',
		最大流量: '最大',
		最新流量: '最新',
		CPU使用量: 'CPU使用率',
		IP地址: 'IPアドレス',
		SSH端口: 'SSHポート',
	},
	备注: '述べる',
	本订单已有未处理的关闭申请工单号: 'この注文には未処理のクローズ申請があります <strong>{no}</strong>',
	本订单已有未处理的售后工单工单号: 'この注文には未処理の販売後チケットがあります <strong>{no}</strong>',
	操作: '操作する',
	操作系统: 'オペレーティング·システム',
	产品: '製品',
	产品到期不续费: '(該製品は有効期限を設定していますが、製品が自動的に終了します。)',
	产品到期续费: '(有効期限前に自動的に請求書が生成されます。)',
	产品价格: '製品価格',
	产品配置: '製品構成',
	产品信息: '製品情報',
	产品选择: '製品の選択',
	带宽: '帯域幅',
	单价: '単価',
	到期不续费: '到期不續費',
	到期日期: '有効期限',
	登录信息: 'ログイン情報',
	订单: '注文',
	订单编号: '注文番号',
	订单编号将于多少时间后关闭: '注文 {no} は {time} 以内に終了します',
	订单管理: '注文管理',
	订单类型: '注文タイプ',
	订单信息: '注文情報',
	订单支付成功后将续费至日期: 'お支払い完了後、この注文は <strong>{date}</strong> まで更新されます',
	端口: 'ポート',
	发票信息: '請求書情報',
	返回: '戻る',
	'服务器/cpu': 'サーバー/CPU',
	附加IP地址: '追加のIPアドレス',
	复制: 'コピー',
	复制信息: '情報をコピーする',
	该产品需要实名认证达标后购买: 'この製品を購入するには、実名認証が基準レベルに達している必要があります',
	个: '個',
	更多: 'もっと',
	购买物理机: '物理マシンを購入する',
	购买云主机: 'クラウドホスティングを購入する',
	关闭订单: '注文を閉じる',
	关闭订单标题: '注文 {no} の解約',
	关闭订单内容: '注文 {no} の解約申請、製品 {product}、有効期限 {date}',
	关闭原因必填: '理由を入力してください',
	关闭原因占位: '理由を記入してください（例：不要になった、他社に移行など）',
	核心: 'Core',
	恢复续费账单: '恢復續費賬單',
	机房: 'エンジンルーム',
	'机房/线路': 'コンピュータ室・ライン',
	计费: '請求する',
	计价周期: '評価サイクル',
	价格: '価格',
	开通日期: '開業日',
	'开通日期/到期日期': '開封日・賞味期限',
	'开通日期/结束日期': '開通日・終了日',
	可选产品: 'オプション品',
	可选线路: 'オプションライン',
	控制台: 'コンソール',
	库存: '在庫',
	库存不足无法下单: '在庫不足のため注文できません',
	类型: 'タイプ',
	历史订单: '履歴注文',
	密码: 'パスワード',
	名称: '名前',
	默认带宽: 'デフォルト帯域幅',
	默认内存: 'デフォルトメモリ',
	默认区域: 'デフォルトエリア',
	默认数据盘: 'デフォルトデータディスク',
	默认系统盘: 'デフォルトシステムディスク',
	默认CPU: 'デフォルトvCPU',
	默认IP数量: 'デフォルトIP数',
	内存: 'メモリ',
	配置: '構成',
	处理中: '処理中',
	请填写关闭原因: '理由を入力してください。担当者が対応します。',
	请至少改变一个配置: '少なくとも 1 つの構成を変更してください',
	区域: 'エリア',
	取消: 'キャンセル',
	缺货: '在庫切れ',
	确认关闭编号为编号的订单: '注文番号 <strong>{no}</strong> を閉じることを確認しますか?',
	确认关闭订单提示: '注文 <strong>{no}</strong> の解約申請を送信しますか？担当者が対応します。',
	'确认要到期不续费吗？': '確認要到期不續費嗎？',
	'确认要恢复续费账单吗？': '確認要恢復續費賬單嗎？',
	申请已提交工单号: 'チケットを送信しました。<strong>{no}</strong>',
	升级配置: 'アップグレード構成',
	生成发票: '更新する',
	剩余: '残り',
	试用开通日期: 'トライアル開始日',
	试用中: 'トライアル中',
	输入订单编号查询: '注文番号を入力して問い合わせる',
	数据盘: 'データディスク',
	刷新: 'リフレッシュする',
	提交订单: '注文を送信する',
	提示: 'ヒント',
	网络: 'ネットワーク',
	未关联主机: '関連するホストはありません',
	系统盘: 'システムディスク',
	下单时间: '注文時間',
	线路: 'ライン',
	线路带宽: '回線帯域幅',
	详情: '詳細',
	修改配置后生成: '構成変更後に生成されます',
	已启用: '有効',
	已失效: '無効',
	已停用: '無効化されました',
	硬盘: 'ハードディスク',
	用户名: 'ユーザー名',
	远程端口: 'リモートポート',
	月: '月',
	暂无可用线路: 'まだ利用可能な回線はありません',
	支付: '請求書を支払う',
	支付补差价: '差額を支払う',
	重置配置: '構成をリセット',
	主机名: 'ホスト名',
	主机信息: 'ホスト情報',
	状态: '州',
	字段不能小于原配置: '{field}は元の構成より小さくすることはできません',
	自定义: 'カスタマイズ',
	自动生成: '自動生成',
	自动续费: '自動更新',
	总计: '合計',
	IP地址: 'IPアドレス',
	IP配置: 'IP構成',
	IP数量: 'IPの数',
	IP数量限制: 'IP数制限',
	MAC地址: 'MACアドレス',
	VPS信息: 'VPS情報',
}
